export default import.meta.ROLLUP_FILE_URL_HreJjduz7ThEDqm$vO4fGQ